
/* styles */
require("!!../../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-4a15459f&scoped=true!stylus-loader?{\"sourceMap\":true}!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./feed.vue")

var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./feed.vue"),
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-4a15459f!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./feed.vue"),
  /* scopeId */
  "data-v-4a15459f",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/features/onlineRoundtables/pages/feed/feed.vue
// module id = 1297
// module chunks = 61